// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import ActivityCard from "../Customer/Activities/ActivityCard/ActivityCard";

// // ActivitiesList Component
// const ActivitiesList = () => {
//   const [activities, setActivities] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [timers, setTimers] = useState({});
//   const [showAllActivities, setShowAllActivities] = useState(false); // State for toggle view
//   const navigate = useNavigate();

//   const currentLocation = localStorage.getItem("userLocation")
//     ? JSON.parse(localStorage.getItem("userLocation"))
//     : {};
//   const locationParams = {
//     longitude: currentLocation?.longitude,
//     latitude: currentLocation?.latitude,
//   };

//   // --- API Fetching Logic ---
//   const fetchActivities = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await axios.get(
//         `https://api.upswap.app/api/activities/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`
//       );

//       const activitiesData = response.data.data || response.data || [];
//       setActivities(activitiesData);
//       setLoading(false);

//       if (activitiesData.length === 0) {
//         toast.info("No activities available.");
//       }
//     } catch (err) {
//       console.error("Error fetching activities:", err);
//       setError("Failed to load activities. Please try again later.");
//       toast.error("Failed to load activities.");
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchActivities();
//   }, [fetchActivities]);

//   // --- Countdown Timer Logic ---
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const updatedTimers = {};
//       activities.forEach((activity) => {
//         if (!activity.infinite_time && activity.end_date) {
//           const now = new Date();
//           const endTime = new Date(activity.end_date); // Ensure this is a valid date string
//           const diff = endTime.getTime() - now.getTime();

//           if (diff > 0) {
//             const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//             const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
//             const minutes = Math.floor((diff / (1000 * 60)) % 60);
//             const seconds = Math.floor((diff / 1000) % 60);

//             updatedTimers[activity.activity_id] = `${days}d ${hours
//               .toString()
//               .padStart(2, "0")}h ${minutes
//               .toString()
//               .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
//           } else {
//             updatedTimers[activity.activity_id] = "Expired";
//           }
//         }
//       });
//       setTimers(updatedTimers);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [activities]);

//   // --- Navigation Handlers ---
//   const handleViewDetails = (activityId) => {
//     navigate(`/ActivitiesDetails/${activityId}`);
//   };

//   // --- Toggle View Logic (Show 6 or All) ---
//   const displayedActivities = useMemo(() => {
//     return showAllActivities ? activities : activities.slice(0, 5);
//   }, [activities, showAllActivities]);

//   // Only show the toggle button if there are more than 6 activities
//   const shouldShowToggleButton = activities.length > 6;

//   // --- Loading, Error, No Activities States ---
//   if (loading) {
//     return (
//       <div className=" bg-white flex items-center justify-center h-screen">
//         {" "}
//         {/* Added h-screen for full height during loading */}
//         <div className="flex flex-col items-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className=" bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4 h-screen">
//         {" "}
//         {/* Added h-screen for full height during error */}
//         <p className="text-red-500">Error: {error}</p>
//         <button
//           onClick={fetchActivities}
//           className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
//         >
//           Retry Loading Activities
//         </button>
//       </div>
//     );
//   }

//   if (activities.length === 0) {
//     return (
//       <div className=" bg-white flex items-center justify-center text-gray-600 text-xl p-4 h-screen">
//         {" "}
//         {/* Added h-screen for full height when no activities */}
//         <p>No activities available yet. Check back soon!</p>
//       </div>
//     );
//   }
//   const handleToggleView = () => {
//     setShowAllActivities((prevState) => !prevState);
//   };

//   // --- Main Render ---
//   return (
//     <div className="bg-white ">
//       {/* Changed py-8 to pt-0 and pb-8 to reduce top gap */}
//       <div className="pt-0 pb-4 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
//         {/* Header and Toggle Button */}
//         <div className="flex justify-between items-center mb-6 mt-2">

//           <div>
//             <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
//               Local Activities & Events
//             </h2>
//             <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
//               Connect with people who share your interests
//             </p>
//           </div>

//           {shouldShowToggleButton && (
//             <button
//               onClick={handleToggleView}
//               className="
//                 flex items-center text-base font-semibold text-orange-500
//                 hover:text-orange-600 transition-colors duration-200
//               "
//             >
//               {/* {showAllActivities ? (
//                 <>
//                   Show Less <ArrowLeft className="ml-2 w-4 h-4" />
//                 </>
//               ) : (
//                 <>
//                   View all activities <ArrowRight className="ml-2 w-4 h-4" />
//                 </>
//               )} */}
//             </button>
//           )}
//         </div>

//         {/* Activities Grid */}

//         <div
//           className="
//     grid gap-x-4 gap-y-3
//     grid-cols-2
//     sm:grid-cols-2
//     md:grid-cols-3
//     lg:grid-cols-4
//     xl:grid-cols-5
//     2xl:grid-cols-5
//   "
//         >
//           {displayedActivities.map((activity) => (
//             <ActivityCard
//               key={activity.activity_id}
//               activity={activity}
//               timerValue={timers[activity.activity_id]}
//               handleViewDetails={handleViewDetails}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ActivitiesList;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import ActivityCard from "../Customer/Activities/ActivityCard/ActivityCard";

const ActivitiesList = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timers, setTimers] = useState({});
  const [showAllActivities, setShowAllActivities] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Get current location from localStorage
  const currentLocation = localStorage.getItem("userLocation")
    ? JSON.parse(localStorage.getItem("userLocation"))
    : {};
  const locationParams = {
    longitude: currentLocation?.longitude,
    latitude: currentLocation?.latitude,
  };

  // Detect screen size (mobile vs desktop)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Tailwind sm: breakpoint
    };
    handleResize(); // Initial run
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch activities from API
  const fetchActivities = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://api.upswap.app/api/activities/lists/?lat=${locationParams?.latitude}&lng=${locationParams?.longitude}`
      );
      const activitiesData = response.data.data || response.data || [];
      setActivities(activitiesData);
      setLoading(false);

      if (activitiesData.length === 0) {
        toast.info("No activities available.");
      }
    } catch (err) {
      console.error("Error fetching activities:", err);
      setError("Failed to load activities. Please try again later.");
      toast.error("Failed to load activities.");
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  // Countdown timers
  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimers = {};
      activities.forEach((activity) => {
        if (!activity.infinite_time && activity.end_date) {
          const now = new Date();
          const endTime = new Date(activity.end_date);
          const diff = endTime.getTime() - now.getTime();

          if (diff > 0) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);
            updatedTimers[activity.activity_id] = `${days}d ${hours
              .toString()
              .padStart(2, "0")}h ${minutes
              .toString()
              .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
          } else {
            updatedTimers[activity.activity_id] = "Expired";
          }
        }
      });
      setTimers(updatedTimers);
    }, 1000);
    return () => clearInterval(interval);
  }, [activities]);

  const handleViewDetails = (activityId) => {
    navigate(`/ActivitiesDetails/${activityId}`);
  };

  // Display only 5 for mobile, 6 or all for desktop
  const displayedActivities = useMemo(() => {
    if (isMobile) {
      return activities.slice(0, 6);
    } else {
      return showAllActivities ? activities : activities.slice(0, 5);
    }
  }, [activities, showAllActivities, isMobile]);

  const shouldShowToggleButton = activities.length > 6 && !isMobile;

  const handleToggleView = () => {
    setShowAllActivities((prev) => !prev);
  };

  // Loading UI
  if (loading) {
    return (
      <div className="bg-white flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#FE7A3A]"></div>
      </div>
    );
  }

  // Error UI
  if (error) {
    return (
      <div className="bg-white flex flex-col items-center justify-center text-gray-700 text-xl p-4 h-screen">
        <p className="text-red-500">Error: {error}</p>
        <button
          onClick={fetchActivities}
          className="mt-4 px-4 py-2 bg-[#FE7A3A] text-white rounded-lg hover:bg-orange-500"
        >
          Retry Loading Activities
        </button>
      </div>
    );
  }

  // No activities
  if (activities.length === 0) {
    return (
      <div className="bg-white flex items-center justify-center text-gray-600 text-xl p-4 h-screen">
        <p>No activities available yet. Check back soon!</p>
      </div>
    );
  }

  // Render
  return (
    <div className="bg-white">
      <div className="pt-0 pb-4 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6 mt-2">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">
              Local Activities & Events
            </h2>
            <p className="text-sm md:text-base text-gray-700">
              Connect with people who share your interests
            </p>
          </div>

          {/* Toggle Button for Desktop */}
          {shouldShowToggleButton && (
            <button
              onClick={handleToggleView}
              className="text-base font-semibold text-orange-500 hover:text-orange-600 transition-colors duration-200"
            >
              {showAllActivities ? "View Less" : "View All"}
            </button>
          )}
        </div>

        {/* Activity Grid */}
        <div
          className="
            grid gap-x-4 gap-y-3
            grid-cols-2
            sm:grid-cols-2
            md:grid-cols-3
            lg:grid-cols-4
            xl:grid-cols-5
            2xl:grid-cols-5
          "
        >
          {displayedActivities.map((activity) => (
            <ActivityCard
              key={activity.activity_id}
              activity={activity}
              timerValue={timers[activity.activity_id]}
              handleViewDetails={handleViewDetails}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActivitiesList;
